import gql from "graphql-tag";
import { deviceFields } from "../../../graphql/fragments";

export const GET_ALL_ZONE_DEVICES = gql`
  query ZoneAllDevices(
    $parentId: ID!
    $organizationSubtype: String
    $type: String
  ) {
    devices(
      parentId: $parentId
      organizationSubtype: $organizationSubtype
      type: $type
    ) {
      ...DeviceFields
      organization {
        id
        name
        parentId
        timeZone
        type
        subtype
        externalId
        ancestors(type: "facility") {
          id
          name
        }
      }
    }
  }
  ${deviceFields}
`;
